import { render, staticRenderFns } from "./ApproverArchivePage.vue?vue&type=template&id=43a32af3&scoped=true&"
import script from "./ApproverArchivePage.vue?vue&type=script&lang=js&"
export * from "./ApproverArchivePage.vue?vue&type=script&lang=js&"
import style0 from "./ApproverArchivePage.vue?vue&type=style&index=0&id=43a32af3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a32af3",
  null
  
)

export default component.exports